import {useState, useMemo} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios as defaultAxios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useBlibliProductList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/get-product-list`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliProductListLoading: loading,
    blibliProductList: data,
    setProductList: setData,
    fetchBlibliProductList: fetchData
  };
};
export const useBlibliProductListModel = createModel(useBlibliProductList);
export const useBlibliShopList = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (shopIds) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.get(`/saas/shop/get-list-by-shop-ids`, {
        params: {
          shopIds
        }
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    shopeeShopListLoading: loading,
    shopeeShopList: data,
    fetchShopeeShopList: fetchData
  };
};
export const useBlibliShopListModel = createModel(useBlibliShopList);
export const BlibliBatchModifyCategoryAttributes = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/batch-modify-category-attributes`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliModifyLoading: loading,
    blibliModify: data,
    fetchBlibliModify: fetchData
  };
};
export const BlibliBatchModifyCategoryAttributesModel = createModel(BlibliBatchModifyCategoryAttributes);
export const useVariationList = () => {
  const [data, setData] = useState({});
  const [attrMapData, setAttrMapData] = useState({});
  const [attrRegexMap, setAttrRegexMap] = useState({});
  const [mandatoryMap, setMandatoryMap] = useState([]);
  const [attrMapType, setAttrMapType] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const defaultData = await defaultAxios.post(`/saas/shop/get-categoryAttributes-list-by-channel`, params);
      let variationMap = {};
      let dataAttributesMap = {};
      let dataAttributesType = {};
      let dataRegexTypeMap = {};
      let mandaMap = {};
      defaultData && defaultData.data.map((data2) => {
        if (!data2.categoryId) {
          return;
        }
        variationMap[data2.categoryId] = [];
        mandaMap[data2.categoryId] = [];
        dataAttributesMap[data2.categoryId] = [];
        if (data2.attributes && data2.attributes.length) {
          data2.attributes.map((attrData) => {
            dataAttributesType[attrData.attributeId] = attrData.type;
            if (attrData.attributeUnitList && attrData.attributeUnitList.length) {
              dataRegexTypeMap[attrData.attributeId] = new RegExp(`${attrData.attributeUnitList.join("|")}`);
            }
            if (attrData.mandatory === true) {
              mandaMap[data2.categoryId] = [
                ...mandaMap[data2.categoryId],
                attrData
              ];
            } else {
              dataAttributesMap[data2.categoryId] = [
                ...dataAttributesMap[data2.categoryId],
                attrData
              ];
            }
          });
        }
      });
      setAttrMapData({...attrMapData, ...dataAttributesMap});
      setMandatoryMap({...mandatoryMap, ...mandaMap});
      setData({...data, ...variationMap});
      setAttrMapType({...attrMapType, ...dataAttributesType});
      setAttrRegexMap({...attrRegexMap, ...dataRegexTypeMap});
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliVariationMapLoading: loading,
    blibliVariationMap: data,
    blibliAttrMapData: attrMapData,
    mandatoryMap,
    attrMapType,
    attrRegexMap,
    fetchVariationMap: fetchData
  };
};
export const useVariationListModel = createModel(useVariationList);
export const useAllShops = () => {
  const [data, setData] = useState([]);
  const [dataMap, setDataMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {
        data: {content}
      } = await defaultAxios.post("/saas/shop/list", {
        page: 0,
        size: 100
      });
      let shopDataMap = {};
      setData(content);
      content.map((data2) => {
        shopDataMap[data2.shopId] = data2;
      });
      setDataMap(shopDataMap);
      return {
        shops: content
      };
    } catch (error) {
      handleError(error);
      return {
        shops: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    shopsLoading: loading,
    shops: data,
    setShops: setData,
    shopDataMap: dataMap,
    fetchShops: fetchData
  };
};
export const useAllShopsModel = createModel(useAllShops);
export const useCategoryRuleChannel = () => {
  const [data, setData] = useState({
    categoryId: "",
    defaultLimit: 2,
    maxLimit: 7,
    minLimit: 90
  });
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post("/saas/shop/get-categoryRule-by-channel", params);
      if (!data2) {
        setData({
          categoryId: "",
          defaultLimit: 2,
          maxLimit: 90,
          minLimit: 7
        });
      } else {
        setData(data2);
      }
      return {
        data: data2
      };
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const reset = () => {
    setData({
      categoryId: "",
      defaultLimit: 2,
      maxLimit: 90,
      minLimit: 7
    });
  };
  return {
    resetCategoryRuleChannel: reset,
    categoryRuleChannelLoading: loading,
    categoryRuleChannel: data,
    fetchCategoryRuleChannel: fetchData
  };
};
export const useCategoryRuleChannelModel = createModel(useCategoryRuleChannel);
export const useCategoryRuleListChannel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post("/saas/shop/get-categoryRule-list-by-channel", params);
      setData(data2);
      return {
        data: data2
      };
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const dataMap = useMemo(() => {
    let InitDataMap = {};
    data.forEach((data2) => {
      InitDataMap[data2.categoryId] = data2;
    });
    return InitDataMap;
  }, [data]);
  return {
    categoryRuleChannelLoading: loading,
    categoryRuleChannel: dataMap,
    fetchCategoryRuleChannel: fetchData
  };
};
export const useCategoryRuleListChannelModel = createModel(useCategoryRuleListChannel);
